import { compose, get } from 'lodash/fp';
import { createAction, createAsyncActionTypes } from '@mews/framework';
import { Profile } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { Identifiable } from '@mews/std';
import { notEmpty } from '@mews-commander/utils';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createBaseEntitySelectors, createEntitiesReducer } from './utils';

export const NAME = 'profiles';

export const PROFILES_LOADED = prefix('PROFILES_LOADED');
export const [PROFILES_LOADED_STARTED, PROFILES_LOADED_SUCCEEDED, PROFILES_LOADED_FAILED] =
    createAsyncActionTypes(PROFILES_LOADED);

export default createEntitiesReducer({
    FETCH_SUCCESS: PROFILES_LOADED_SUCCEEDED,
});

export const setProfiles = (entities: Array<Profile>) => createAction(PROFILES_LOADED_SUCCEEDED, { entities });

export const [getProfiles, getProfilesByIds, getProfilesByOwnerId, getProfile] = createBaseEntitySelectors<
    ApplicationState,
    Profile,
    typeof NAME
>(parentSelector, NAME);

export const hasProfile = compose(notEmpty, getProfile);

export const getProfileName = compose(get('name'), getProfile);

export const getProfileIsActive = compose(get('isActive'), getProfile);

export const getProfileData = (state: ApplicationState, params: Identifiable) => getProfile(state, params)?.data;
